import { trimTextField } from '@/utils';
import { EMAIL_PATTERN, PASSWORD_PATTERN, } from '@/utils/regularExpression';
import { computed } from 'vue';
import { i18n } from '@/locales';
import { validationLimitingValue } from '@/constants';
import { isRequired, greaterThanMinLength, isSameAsLimitLength, isValidPattern, isEndValueGreaterThanStartValue, } from './index';
const { PHONE_MIN_LENGTH, WITHDRAWAL_BANK_ACCOUNT_MIN_LENGTH, BUSINESS_NUMBER_MAX_LENGTH, PASSWORD_MIN_BYTE, } = validationLimitingValue;
const createHubFormRules = (formRuleLc) => ({
    isRequired: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v)) || i18n.t(`${formRuleLc}value_require`),
            ];
        },
        set() { },
    }),
    withdrawalBankAccount: computed({
        get() {
            return [
                (v) => !isRequired(v)
                    || greaterThanMinLength(v.length, WITHDRAWAL_BANK_ACCOUNT_MIN_LENGTH)
                    || i18n.t(`${formRuleLc}wrong_value`),
            ];
        },
        set() { },
    }),
    businessNumber: computed({
        get() {
            return [
                (v) => isRequired(v) || i18n.t(`${formRuleLc}value_require`),
                (v) => isSameAsLimitLength(v.length, BUSINESS_NUMBER_MAX_LENGTH)
                    || i18n.t(`${formRuleLc}wrong_value`),
            ];
        },
        set() { },
    }),
    phone: computed({
        get() {
            return [
                (v) => isRequired(v) || i18n.t(`${formRuleLc}value_require`),
                (v) => greaterThanMinLength(v.length, PHONE_MIN_LENGTH)
                    || i18n.t(`${formRuleLc}greater_than_min_length`, {
                        length: PHONE_MIN_LENGTH,
                    }),
            ];
        },
        set() { },
    }),
    // TODO 서버 유효성 작업 후 적용할 수도 있음
    // https://www.notion.so/barogohq/ceoEmail-056c9e7a9c2945af8b5485f3aa16b33b?d=aa8dcebb0fc24bad99a3f1452e35bb38#056c9e7a9c2945af8b5485f3aa16b33b
    ceoEmail: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v)) || i18n.t(`${formRuleLc}value_require`),
                (v) => isValidPattern(EMAIL_PATTERN, v) || i18n.t(`${formRuleLc}email_type`),
            ];
        },
        set() { },
    }),
    masterPassword: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t(`${formRuleLc}value_require`),
                (v) => greaterThanMinLength(v.length, PASSWORD_MIN_BYTE)
                    || i18n.t(`${formRuleLc}wrong_value`, {
                        length: PASSWORD_MIN_BYTE,
                    }),
                (v) => isValidPattern(PASSWORD_PATTERN, v) || i18n.t(`${formRuleLc}wrong_value`),
            ];
        },
        set() { },
    }),
});
const isValidKilometerProductRange = (minimumKilometerProduct = 0, kilometerProduct = 10) => isEndValueGreaterThanStartValue(minimumKilometerProduct, kilometerProduct);
export { createHubFormRules, isValidKilometerProductRange, };
